import { useCallback } from 'react';
import { useRouter } from 'next/navigation';
import { useStore, useUnit } from 'effector-react';
import { $lastPublishTime } from '@nx-frontend/shared/store/change-events-store';
import { $portalSettings } from '@nx-frontend/shared/store/portal';

export interface NavigateMenuItemPayload {
  path: string;
  originalPath?: string;
  isPrefetch?: boolean;
}

export const useNavigateMenuItem = () => {
  const router = useRouter();
  const [portalSettings] = useUnit([$portalSettings]);
  const lastPublishTime = useStore($lastPublishTime);
  return useCallback(
    ({ path, originalPath, isPrefetch }: NavigateMenuItemPayload) => {
      const params = new URLSearchParams('');
      if (originalPath) {
        params.set('originalurl', originalPath);
      }
      if (lastPublishTime) {
        params.set('ts', lastPublishTime.toString());
      }

      const paramsValue = params.toString();

      const preparedUrl = `/portal/${portalSettings.id}/visual${path}` + (paramsValue.length ? `?${paramsValue}` : '');
      if (isPrefetch) {
        router.prefetch(preparedUrl);
      } else {
        // router.push(preparedUrl, { forceOptimisticNavigation: true }); // Next 14 migration
        router.push(preparedUrl, {});
      }
    },
    [lastPublishTime, portalSettings, router]
  );
};
